import { AnnouncementApi } from './http-common';

const authorizationHeaders = () => {
  const token = localStorage.getItem('vue-token');

  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const findActiveAnnouncements = () => AnnouncementApi
  .get('active', { headers: authorizationHeaders() })
  .then(response => response.data);

export const findAllAnnouncements = () => AnnouncementApi
  .get('', { headers: authorizationHeaders() })
  .then(response => response.data);

export const createAnnouncement = announcement => AnnouncementApi
  .post('', announcement, { headers: authorizationHeaders() })
  .then(response => response.data);

export const updateAnnouncement = (id, announcement) => AnnouncementApi
  .put(`${id}`, announcement, { headers: authorizationHeaders() })
  .then(response => response.data);

export const deleteAnnouncement = id => AnnouncementApi
  .delete(`${id}`, { headers: authorizationHeaders() });
